import { render, staticRenderFns } from "./Broadcasting.vue?vue&type=template&id=33be8141&scoped=true&"
import script from "./Broadcasting.vue?vue&type=script&lang=js&"
export * from "./Broadcasting.vue?vue&type=script&lang=js&"
import style0 from "./Broadcasting.vue?vue&type=style&index=0&id=33be8141&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33be8141",
  null
  
)

export default component.exports